import React, { useCallback } from 'react';

import { Flex, SubPage, CourseCardEdit } from '../../../../ui';
import { useCourse, useCourseToc, useCourseDurationsState, useUpdateCourse } from '../../hooks';
import CourseInfoEdit from './CourseInfoEdit';
import CourseDripContentEdit from './CourseDripContentEdit';
import CourseDiplomaEdit from './CourseDiplomaEdit';
import { useTranslation } from 'react-i18next';
import { useFeatures } from '../../../settings/hooks';

const CourseSettings = () => {
  const updateCourse = useUpdateCourse();
  const { t } = useTranslation();

  const course = useCourse();
  const courseToc = useCourseToc();
  const courseDurations = useCourseDurationsState(true);
  const features = useFeatures();

  const onSaveCourseInfo = useCallback((updatedCourse) => {
    const courseData = {
      ...updatedCourse,
      id: course.id
    };
    updateCourse({ courseData });
  }, [course, updateCourse]);

  const saveImage = useCallback(image => {
    if (image && course) {
      const categories = course.categories?.map(cat => typeof cat === 'string' ? cat : cat.slug) || [];
      const courseData = {
        description:course.description,
        categories,
        id: course.id,
        coverImage: { id: image.id }
      };
      updateCourse({ courseData });
    }
  }, [course, updateCourse])

  return (
    <SubPage align='left'>
      <Flex align='flex-start' gap={30} breakPoint={{ size: 'tablet', value: 'flex-direction: column; align-items:center' }}>
        <CourseCardEdit
          key={course.id}
          saveImage={saveImage}
          course={course}
          label={t('settings.addImage')}
        />
        <Flex direction='column' gap='50' align='flex-start' width='100%'>
          <CourseInfoEdit course={course} courseDurations={courseDurations} onSaveInfo={onSaveCourseInfo} />
          { features.diplomas && <CourseDiplomaEdit course={course} /> }
          <CourseDripContentEdit course={course} courseToc={courseToc} />
        </Flex>
      </Flex>
    </SubPage >
  );
};

export default CourseSettings;
